import { Reducer } from "redux";

import { DeleteTrainingVideoResponse } from "../models/api/Training";
import { DeleteTrainingVideoDispatchTypes } from "../models/dispatchTypes/Training";
import { DeleteTrainingVideoActionDispatchTypes } from "../constants/Training";

const initialState: DeleteTrainingVideoResponse = {
  loading: false,
  response: "",
  error: null,
};

const DeleteTrainingVideoReducer: Reducer<
  DeleteTrainingVideoResponse,
  DeleteTrainingVideoDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DeleteTrainingVideoReducer;
